
import { firebase_Db} from '../../src/config/firebaseConfig';

const DBName = "messages";

const CreateNewMessages = async ({title, duration,reciverType}) => {
    const ref = firebase_Db.collection(DBName).doc();
    return await firebase_Db.collection(DBName).add({
        id: ref.id,
        title: title,
    duration: duration,
    reciverType: reciverType

  });

}


const UpdateMessages = async ({id, title, duration}) => {
    return await firebase_Db.collection(DBName).doc(id).update({
        title: title,
        duration: duration,
    });
}

const deleteMessages = async (id) => {
    return await firebase_Db.collection(DBName).doc(id).delete();
}

const getMessages = async () => {
    return await firebase_Db.collection(DBName).orderBy("createdAt", "desc").get();
}




export {CreateNewMessages, UpdateMessages, deleteMessages, getMessages};